import React, { Fragment } from "react";
import Nav from "../nav/Nav";
import MyBook from "../page/Flipbook";
import MyBookCel from "../page/FlipbookCel";
import { Container, Row } from "react-bootstrap";
import {  getToken, hasExpiredToken, removeToken } from "../../api/token";
import './Flip.css';

export default class Flip extends React.Component {

 componentDidMount(){
      const token = getToken();
      if(token){
        const respuesta =  hasExpiredToken(token);
        if(respuesta == true){
          removeToken()
          window.location.href = "./";
        }
      }
     
      if(!token){
        window.location.href = "./";
      }
    
    
    }

  render(){
  
      return (
      
    <Fragment className="contenedorFlipbook">
      <Nav />
      <Container>
      <Row>
        </Row>
      </Container>
     
       
      <Container>
    
      <div className="flipbookComputadora">
          <MyBook />
      </div>
      <div className="flipbookCelular">
          <MyBookCel/>
      </div>

      </Container>

     
     
    </Fragment>
  );
}
  
}
